module.exports = __webpack_public_path__ + "img/manager.793d98a8.svg";